namespace app.tarefas.minhasTarefas {
    "use strict";

    import IHttpService = ng.IHttpService;
    import IPromise = ng.IPromise;
    import IQService = ng.IQService;
    import IDocumentService = ng.IDocumentService;
    import IDialogService = ng.material.IDialogService;
    import IStateService = ng.ui.IStateService;
    import Properties = app.support.constants.Properties;
    import IUser = app.autenticacao.IUser;
    import Command = app.support.command.Command;
    import CommandService = app.support.command.CommandService;
    import CommandValidator = app.support.command.CommandValidator;
    import CommandConfig = app.support.command.CommandConfig;
    import MessagesService = app.support.messaging.MessagesService;
    import AuthService = app.autenticacao.AuthService;
    import INotification = app.notification.INotification;
    import IdentidadesService = app.support.identidades.IdentidadesService;

    declare let angular: ng.IAngularStatic;
    declare let _: _.LoDashStatic;

    export interface IGroup {
        id: number;
        nome: string;
        nomeArvore: string;
        tipo: string;
        pai: number;
        subgrupos: IGroup[];
    }

    export interface IResource {
        nome: string;
        contexto: string;
        tipo: string;
        somenteLeitura: boolean;
    }

    export interface ITaskTag {
        id: string;
        tasks: Array<string>;
        type: string;
        name: string;
        color: string;
        tooltip: string;
        tenantsPermitidos: Array<string>;
        origem: ITaskTagOrigem;
    }

    export enum ITaskTagOrigem {
        MANUAL = "MANUAL",
	    AUTOMATICA = "AUTOMATICA"
    }

    export interface ITaskAttachment {
        name: string;
        size: number;
    }

    export interface Tenant {
        // Campos do Digital
        codigo: string;
        nome: string;
        sigla: string;        
    }

    export interface ITask {
        id: string;
        context: string;
        title: string;
        command: string;
        startDate: string;
        completedDate: string;
        completed: boolean;
        priority: boolean;
        notes: string;
        tags: ITaskTag[];
        etags: string[];
        informationId: string;
        attachments: ITaskAttachment[];
        selected?: boolean;
        searchableId: string;
        assignee: string;
        claimDate: number;
        assignor: string;
        assigneeGroup: number;
        cancelable: boolean;
        draft: ITaskDraftBasic;
        cancellation: ITaskCancellation;
        extraInfo: { [key: string]: string };
        readOnly: boolean;
        selfAssigned?: boolean;
        restricted?: boolean;
        isView: boolean;
    }

    export interface ITaskDraftBasic {
        valid: boolean;
        modifiedBy: string;
        modifiedDate: number;
    }

    export interface ITaskDraft extends ITaskDraftBasic {
        context: string;
        taskId: string;
        commandId: string;
        commandJSON: {};
    }

    export interface ITaskCancellation {
        reason: string;
        canceledBy: string;
        canceledDate: string;
    }

    export abstract class TaskCommand implements Command {

        constructor(public context: string, public taskId: string) { }
    }

    export class SetPriorityTaskCommand extends TaskCommand {

        public priority: boolean = false;
    }

    export class SetNotesTaskCommand extends TaskCommand {

        public notes: string = "";
    }

    export class SetTagsTaskCommand extends TaskCommand {

        public tags: string[] = [];
    }

    export class RemoveTagTaskCommand extends TaskCommand {

        public tag: string;
    }
	
    export abstract class ContextTasksCommand implements Command {

        public contextTasks: {};

        constructor() { }

        public addTasks(tasks: ITask[]): void {
            if (angular.isArray(tasks)) {
                tasks.forEach((task) => this.addTask(task));
            }
        }

        public addTask(task: ITask): void {
            if (this.contextTasks && this.contextTasks[task.context]) {
                this.contextTasks[task.context].push(task.id);
            } else {
                this.contextTasks = {};
                this.contextTasks[task.context] = [task.id];
            }
        }
    }

    export class AssumeTasksCommand extends ContextTasksCommand {

        constructor() {
            super();
        }
    }

    export class AssigneeTasksCommand extends ContextTasksCommand {

        public assignee: string;

        constructor() {
            super();
        }
    }

    export class AssigneeTasksCommandValidator implements CommandValidator {

        public isValid(command: AssigneeTasksCommand): boolean {
            return !!command.contextTasks;
        }
    }

    export class AssigneeGroupTasksCommand extends ContextTasksCommand {

        public assigneeGroup: number;

        constructor() {
            super();
        }
    }

    export class AssigneeTagTasksCommand {

        public tags: string[] = [];
        constructor(public tasks: ITask[]) { }
    }

    export class UnAssigneeTagTasksCommand {

        public tags: string[] = [];
        constructor(public tasks: ITask[]) { }
    }

    export class AssigneeGroupTasksCommandValidator implements CommandValidator {

        public isValid(command: AssigneeGroupTasksCommand): boolean {
            return !!command.contextTasks;
        }
    }

    export class CancelTasksCommand extends ContextTasksCommand {

        public reason: string;

        constructor() {
            super();
        }
    }

    export class CancelTasksCommandValidator implements CommandValidator {

        public isValid(command: CancelTasksCommand): boolean {
            if (!!command.reason) {
                if (command.reason.length === 1) {
                    command.reason = command.reason.trim();
                }
                return command.reason.length > 0 && command.reason.length <= 500 && !!command.contextTasks;
            }
            return false;
        }
    }

    export class SetNotesTaskCommandValidator implements CommandValidator {

        public isValid(command: SetNotesTaskCommand): boolean {
            if (!!command.notes) {
                if (command.notes.length === 1) {
                    command.notes = command.notes.trim();
                }
                return command.notes.length > 0 && command.notes.length <= 500;
            }
            return false;
        }
    }

    export class SetTagsTaskCommandValidator implements CommandValidator {

        public isValid(command: SetTagsTaskCommand): boolean {
            if (!!command.tags) {
                return command.tags.length > 0;
            }
            return false;
        }
    }

    export class RemoveTagTaskCommandValidator implements CommandValidator {

        public isValid(command: RemoveTagTaskCommand): boolean {
            return !!command.tag;
        }
    }

    export class CamposExportacaoTarefa {

        constructor(public nome: string = '', 
            public descricao: string, 
            public isAtivo: boolean, 
            public tipo: string, 
            public funcaoDeFormatacao: string = '') { }
    }

    export class MinhasTarefasService {

        private apiTarefas: string;
        private apiTarefasHistorico: string;
        private apiUsuarios: string;

        /** @ngInject **/
        public constructor(private $http: IHttpService,
                           private $q: IQService,
                           private $document: IDocumentService,
                           private $state: IStateService,
                           private $mdDialog: IDialogService,
                           private commandService: CommandService,
                           private messagesService: MessagesService,
                           private authService: AuthService,
                           private properties: Properties,
                           private identidadesService: IdentidadesService) {

            this.apiTarefas = properties.apiUrl + "/integracoes-modulos/api/tasks";
            this.apiTarefasHistorico = properties.apiUrl + "/integracoes-tarefas/api/tasks";
            this.apiUsuarios = properties.apiUrl + "/integracoes-identidades/api/acessos";
            this.commandService.addValidator("atribuir-tarefas", new AssigneeTasksCommandValidator());
            this.commandService.addValidator("atribuir-tarefas-grupo", new AssigneeGroupTasksCommandValidator());
            this.commandService.addValidator("cancelar-tarefas", new CancelTasksCommandValidator());
            this.commandService.addValidator("anotar-tarefa", new SetNotesTaskCommandValidator());
            this.commandService.addValidator("rotular-tarefa", new SetTagsTaskCommandValidator());
            this.commandService.addValidator("remover-rotulo-tarefa", new RemoveTagTaskCommandValidator());
        }

        public get(): IPromise<ITask[]> {
            return <IPromise<ITask[]>>this.$http.get(this.apiTarefas);
        }

        public getNomesUsuarios(logins: string[]): IPromise<{}> {
            return this.identidadesService.getNomeApresentacao(logins);
        }

        public loadTaskDraft(task: ITask): IPromise<ITaskDraft> {
            return <IPromise<ITaskDraft>>this.$http.get(`${this.apiTarefas}/draft/${task.context}/${task.id}`);
        }

        public deleteTaskDraft(task: ITask): IPromise<ITaskDraft> {
            return <IPromise<ITaskDraft>>this.$http.delete(`${this.apiTarefas}/draft/${task.context}/${task.id}`);
        }

        public setPriority(cmd: SetPriorityTaskCommand): IPromise<{}> {
            return this.$http.post(`${this.apiTarefas}/priority`, cmd);
        }

        public setNotes(cmd: SetNotesTaskCommand): IPromise<{}> {
            return this.$http.post(`${this.apiTarefas}/notes`, cmd);
        }

        public setTags(cmd: SetTagsTaskCommand): IPromise<{}> {
            return this.$http.post(`${this.properties.apiUrl}/${cmd.context}/api/tasks/${cmd.taskId}/tags`, cmd);
        }

        public setTagsTasks(cmd: AssigneeTagTasksCommand): ng.IPromise<{}> {
            let promisses = [];
            cmd.tasks.forEach(task => {
                let command = new SetTagsTaskCommand(task.context, task.id);
                command.tags = cmd.tags;
                promisses.push(this.setTags(command));
            });
            return this.$q.all(promisses);
        }

        public unsetTagsTasks(cmd: UnAssigneeTagTasksCommand): ng.IPromise<{}> {
            let promisses = [];
            
            if(!!cmd.tasks && !!cmd.tags) {
                cmd.tasks.forEach(task => {
                    let promise = this.$q.resolve({});
                    cmd.tags
                        .filter(tag => task.tags.some(t => t.id === tag))
                        .forEach(tag => {
                            let command = new RemoveTagTaskCommand(task.context, task.id);
                            command.tag = tag;
                            promise = promise.then(() => this.removeTag(command));
                    });
                    promisses.push(promise);
                });
            }
            return this.$q.all(promisses);
        }

        public removeTag(cmd: RemoveTagTaskCommand): IPromise<{}> {
            return this.$http.delete(
                `${this.properties.apiUrl}/${cmd.context}/api/tasks/${cmd.taskId}/tags/${cmd.tag}`);
        }

        public assignTasks(cmd: AssigneeTasksCommand): IPromise<{}> {
            return this.$http.post(`${this.apiTarefas}/assignment`, cmd);
        }

        public assignGroupTasks(cmd: AssigneeGroupTasksCommand): IPromise<{}> {
            return this.$http.post(`${this.apiTarefas}/group/assignment`, cmd);
        }

        public assumeTasks(cmd: AssumeTasksCommand): IPromise<{}> {
            return this.$http.post(`${this.apiTarefas}/user`, cmd);
        }

        public cancelTasks(cmd: CancelTasksCommand): IPromise<{}> {
            cmd.reason = cmd.reason.trim();
            return this.$http.post(`${this.apiTarefas}/canceled`, cmd);
        }

        public listCanceledTasks(from?: number, to?: number, filterDefault?: boolean): IPromise<ITask[]> {
            let config: ng.IRequestShortcutConfig = {
                params: {
                    from: from,
                    to: to,
                    filterDefault: filterDefault,
                }
            };
            return this.$http
                .get(`${this.apiTarefasHistorico}/canceled`, config)
                .then((response: ng.IHttpPromiseCallbackArg<ITask[]>) => response.data, () => []);
        }

        public listCompletedTasks(from?: number, to?: number, filterDefault?: boolean): IPromise<ITask[]> {
            let config: ng.IRequestShortcutConfig = {
                params: {
                    from: from,
                    to: to,
                    filterDefault: filterDefault
                }
            };
            return this.$http
                .get(`${this.apiTarefasHistorico}/completed`, config)
                .then((response: ng.IHttpPromiseCallbackArg<ITask[]>) => response.data, () => []);
        }

        public listUsersByResources(resources: IResource[], filterBySetorUsuario: boolean): IPromise<IUser[]> {
            let query = { permissoes: resources, lotacao: null };
            let login = this.authService.getUserLogin();

            if (filterBySetorUsuario) {
                return this.authService.getUser()
                    .then(user => {
                        query.lotacao = user.lotacao;
                        return <IPromise<IUser[]>>this.$http.post(`${this.apiUsuarios}/usuarios/recursos`, query)
                            .then((response: ng.IHttpPromiseCallbackArg<IUser[]>) => {
                                return response.data.filter(user => user.login !== login);
                            });
                    });
            }
            return <IPromise<IUser[]>>this.$http.post(`${this.apiUsuarios}/usuarios/recursos`, query)
                .then((response: ng.IHttpPromiseCallbackArg<IUser[]>) => {
                    return response.data.filter(user => user.login !== login);
                });
        }

        public listGroups(): IPromise<IGroup[]> {
            return this.$http.get(`${this.apiUsuarios}/usuario/grupos?tipo=SETOR`, { cache: true })
                .then((response: ng.IHttpPromiseCallbackArg<IGroup[]>) => {
                    let groups = [];
                    response.data.forEach(g => this.addSubgroups(g, groups));
                    return _.orderBy(groups, "nomeArvore");
                });
        }

        public notifyOpenTask(notification: INotification): void {
            let task: ITask = notification.content;
            this.$q.all([this.commandService.findByIdAndContext(task.command, task.context), this.authService.getUser()])
                .then((values) => {
                    if (values[0].notifyToOpenTask && values[1].login === notification.sender) {
                        this.messagesService.task(`Tarefa criada "${task.title}"`, "Abrir")
                            .then((response) => {
                                if (response === "ok") {
                                    this.openTask(task);
                                }
                            });
                    }
                });
        }

        public openTask(task: ITask): void {
            this.authService.getUser().then((user) => {
                if (task.assignee === null) {
                    let cmd = new AssumeTasksCommand();
                    cmd.addTask(task);

                    return this.assumeTasks(cmd)
                        .then(() => {
                            this.loadTask(task);
                            task.assignee = user.login;
                            task.selfAssigned = true;
                            return task;
                        });
                }
                else {
                    if (task.assignee !== user.login) {
						this.getNomesUsuarios([task.assignee]).then(resultado => {
							let nomeUsuario = task.assignee;
							for (const [key, value] of Object.entries(resultado)) {
								nomeUsuario = value;
							}
							this.assumeDialog(task, nomeUsuario).then((response) => {
                                let cmd = new AssumeTasksCommand();
                                cmd.addTask(task);

                                this.assumeTasks(cmd)
                                    .then(() => {
                                        task.assignee = user.login;
                                        task.selfAssigned = true;
                                        this.loadTask(task);
                                    });
                            });
						});
                    } else {
                        this.loadTask(task);
                    }
                }
            });
        }

        public assumeTask(task: ITask): ng.IPromise<ITask> {
            return this.authService.getUser().then((user) => {
                if (task.assignee === null) {
                    let cmd = new AssumeTasksCommand();
                    cmd.addTask(task);

                    return this.assumeTasks(cmd)
                        .then(() => {
                            task.assignee = user.login;
                            task.selfAssigned = true;
                            return task;
                        });
                } else if (task.assignee !== user.login) {
					this.getNomesUsuarios([task.assignee]).then(resultado => {
						let nomeUsuario = task.assignee;
						for (const [key, value] of Object.entries(resultado)) {
							nomeUsuario = value;
						}
						return this.assumeDialog(task, nomeUsuario).then((response) => {
                            let cmd = new AssumeTasksCommand();
                            cmd.addTask(task);

                            return this.assumeTasks(cmd).then(() => {
                                task.assignee = user.login;
                                task.selfAssigned = true;
                                return task;
                            });
                        });
					});
                } else {
                    return task;
                }
            });
        }

        public isTaskAssignedToLoggedUser(task: ITask): ng.IPromise<boolean> {
            return this.authService.getUser().then((user) => {
                return task.assignee === user.login;
            });
        }

        public viewTask(task: ITask, additionalParams?: Map<String, Object>): void {
            this.loadTask(task, additionalParams, true);
        }

        public deleteTaskDraftByNotification(notification: INotification): void {
            this.authService.getUser().then((user) => {
                if (notification.sender === user.login) {
                    let task: ITask = notification.content;
                    this.deleteTaskDraft(task);
                }
            });
        }

        private assumeDialog(task: ITask, nomeUsuario: string): ng.IPromise<{}> {
            return this.authService.getUser().then((user) => {
                let title: string;
                let content: string;

                if (task.assignee && task.assignee !== user.login) {
                    title = `Tarefa atribuída a outro usuário!`;
                    content = `A tarefa '${task.title}' foi atribuída a '${nomeUsuario}'. `;
                } else {
                    title = `Assumir tarefa?`;
                    content = `A tarefa não possui responsável. `;
                }
                content += `Deseja assumi-la?`;

                return this.$mdDialog.show(this.$mdDialog.confirm()
                    .title(title)
                    .textContent(content)
                    .clickOutsideToClose(false)
                    .parent(this.$document.find("body"))
                    .ok("Assumir")
                    .cancel("Cancelar"));
            });
        }

        private loadTask(task: app.tarefas.minhasTarefas.ITask, additionalParams?: Map<String, Object>, isView: boolean = false): void {
            this.authService.getUser().then((user) => {
                task.isView = isView;
                if (task.assignee && task.assignee === user.login) {
                    task.selfAssigned = true;
                }
                this.commandService.findByIdAndContext(task.command, task.context)
                    .then(command => this.openTaskWithDraft(task, command, additionalParams))
                    .catch(reason => {
                        this.messagesService.error(`Você não tem permissão para abrir a tarefa: ${task.title}.`);
                        throw new Error(reason);
                    });
            });
        }

        private openTaskWithDraft(task: ITask, command: CommandConfig, additionalParams?: Map<String, Object>) {
            let contextTask = angular.copy(task);

            if (!command.route || !command.route.types || command.route.types.find(x => x == 'ui1')) {
                if (task.draft && task.draft.modifiedBy && task.draft.modifiedDate) {
                    let draft: ITaskDraft;
                    this.loadTaskDraft(task)
                        .then(taskDraft => {
                            if (taskDraft) { draft = <ITaskDraft>taskDraft.commandJSON; }
                        }).finally(() => {
                            this.$state.go(
                                command.route.stateName,
                                Object.assign({ task: contextTask, draft: draft }, additionalParams));
                        });
                } else {
                    this.$state.go(command.route.stateName, Object.assign({ task: contextTask }, additionalParams));
                }
            } else if (command.route.types.find(x => 'ui2')) {
                this.$state.go(
                    'app.upgraded',
                    Object.assign({ url: `tarefas/${task.context}/${task.id}` }));
            }
        }

        private addSubgroups(group: IGroup, groups: IGroup[]): void {
            groups.push(group);

            if (!!group.subgrupos && group.subgrupos.length > 0) {
                group.subgrupos
                    .filter(g => groups.findIndex((group) => group.id === g.id) == -1)
                    .forEach(g => this.addSubgroups(g, groups));
                group.subgrupos = [];
            }
        }
    }

    const SERVICE_NAME: string = "app.tarefas.minhas-tarefas.MinhasTarefasService";

    let config = /** @ngInject */(errorHandlerProvider, httpPromiseTransformationProvider, $provide) => {
        httpPromiseTransformationProvider.decorate($provide, SERVICE_NAME);
        errorHandlerProvider.decorate($provide, SERVICE_NAME);
    };

    angular
        .module("app.tarefas.minhas-tarefas")
        .service(SERVICE_NAME, MinhasTarefasService)
        .config(config);
}